export var isRangeParams = function isRangeParams(params) {
  return !!params.range;
};
export var isNotRangeParams = function isNotRangeParams(params) {
  return !params.range;
};
export var getIconColor = function getIconColor(disabled, invert) {
  if (disabled) {
    return invert ? 'disabled-invert' : 'disabled';
  }
  return invert ? 'tertiary-invert' : 'tertiary';
};